import styled from 'styled-components';
import FormGroup from 'components/common/FormGroup';
import Checkbox from 'components/common/Checkbox';
import Input from 'components/common/Input';
import Container from '../common/Container';

export const UserSignInStyled = styled(Container)``;

export const LoginForm = styled(FormGroup)``;

export const InputStyled = styled(Input)``;

export const SignUp = styled.p`
  padding: 0.5rem;
  text-align: center;
`;

export const Row = styled.div`
  display: flex;
  margin-top: 20px;
`;

export const RememberMe = styled(Checkbox)`
`;

export const ForgotPassword = styled.a`
  margin-left: auto;

  @media (max-width: 500px) {
    margin-left: 20px;
  }
`;
